// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"637":"01c8aac0","713":"259d7a0f"}[chunkId] + ".chunk.css";
};